import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingService } from '../../../core/services/loading.service';

@Component({
    selector: 'app-global-spinner',
    imports: [CommonModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
    <div class="gs-overlay" *ngIf="loading.visible$ | async" aria-live="polite" aria-busy="true">
      <div class="gs-ring" role="status" aria-label="Loading">
        <svg viewBox="0 0 50 50" width="42" height="42">
          <circle cx="25" cy="25" r="20" fill="none" stroke="#059669" stroke-width="4"
                  stroke-linecap="round" stroke-dasharray="90 60" />
        </svg>
      </div>
    </div>
  `,
    styleUrls: ['./global-spinner.component.scss']
})
export class GlobalSpinnerComponent {
  constructor(public loading: LoadingService) {}
}
